import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AvailableTrafficPack } from '../../interfaces/available-traffic-pack';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app-state';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AppActions } from '../../../store/app-actions';
import { TrafficPacksService } from '../../services/traffic-packs.service';
import { AssistPaymentInfoArgs } from '../../interfaces/assist-payment-info-args';
import { AssistPaymentInfo } from '../../interfaces/assist-payment-info';
import { MessageService } from 'primeng/api';
import { CommonData } from '../../../interfaces/common-data';
import { PersistanceService } from '../../../services/persistance.service';
import {TrafficPackExpireInfo} from '../../interfaces/traffic-pack-expire-info';

@Component({
  selector: 'app-assist-payment-form',
  templateUrl: './assist-payment-form.component.html',
  styleUrls: ['./assist-payment-form.component.less']
})
export class AssistPaymentFormComponent implements OnInit, OnDestroy {

  @Input() trafficPack: AvailableTrafficPack;
  @Input() pnoId: number;

  form = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required, Validators.maxLength(45)]),
    lastName: new UntypedFormControl('', [Validators.required, Validators.maxLength(45)]),
    email: new UntypedFormControl('', [Validators.required, Validators.maxLength(45), Validators.email]),
  });

  returnUrl = window.location.href;
  paymentInfoSubscription?: Subscription;
  commonData?: CommonData | null;

  expireInfoSubscription?: Subscription;
  expireInfo?: TrafficPackExpireInfo;
  expireInfoLoading = true;

  constructor(private trafficPacksService: TrafficPacksService,
              private store: Store<{app: AppState}>,
              private changeDetectorRef: ChangeDetectorRef,
              private persistanceService: PersistanceService,
              private messageService: MessageService) { }

  ngOnInit(): void {
    // Getting common data
    this.store.select('app', 'commonData')
      .pipe(take(1))
      .subscribe(commonData => {
        this.commonData = commonData;
      });

    // Getting contract data from store
    this.store.select('app', 'contractData')
      .pipe(
        take(1),
      )
      .subscribe(contractData => {

        // Patching form fields
        this.form.patchValue({
          firstName: contractData?.first_name,
          lastName: contractData?.last_name,
          email: contractData?.email,
        });

        this.trafficPack.loading = false;
      });

      if (this.trafficPack?.id) {
        this.expireInfoSubscription = this.trafficPacksService.getTrafficPackExpireInfo(this.trafficPack?.id)
          .subscribe(response => {
            this.expireInfoLoading = false;
            if (response && response?.exp_info){
              this.expireInfo = response;
            }
          });
      }
  }

  ngOnDestroy(): void {
    this.paymentInfoSubscription?.unsubscribe();
    this.expireInfoSubscription?.unsubscribe();
  }

  setAssistPaymentInfoArgsToLocalStorage(args: AssistPaymentInfoArgs): void {
    this.persistanceService.set('userEmail', args.email);
    this.persistanceService.set('userFirstName', args.first_name);
    this.persistanceService.set('userLastName', args.last_name);
  }

  submitForm(): void {
    this.form.markAllAsTouched();

    if ( this.form.invalid || !this.trafficPack ) { return; }

    this.trafficPack.loading = true;

    const args: AssistPaymentInfoArgs = {
      is_mobile: false,
      first_name: this.form.get('firstName')?.value,
      last_name: this.form.get('lastName')?.value,
      email: this.form.get('email')?.value,
      traffic_pack_id: this.trafficPack?.id,
      return_url: this.returnUrl
    };

    this.setAssistPaymentInfoArgsToLocalStorage(args);

    this.paymentInfoSubscription = this.trafficPacksService.getAssistPaymentInfo(args)
      .subscribe(response => {
        setTimeout(() => {
          this.trafficPack.loading = false;
        }, 5000);

        // Saved contract data to Store
        this.store.dispatch(AppActions.setContractData({contractData: {
            email: args.email,
            first_name: args.first_name,
            last_name: args.last_name
          }}));

        // Reacting to server response
        if (response.success && response.payment_info?.payment_url) {
          window.location.href = response.payment_info.payment_url;
        } else {
          // Error handling
          this.messageService.add({
            severity: 'error',
            summary: 'Ошибка',
            detail: response.error,
            life: 10 * 1000,
          });
        }
      });

  }

}
